'use client';

import React from 'react';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { useInView } from '../../../../lib/hooks/useInView';
import styles from './BigTitleTwoColumns.module.css';

interface BigTitleTwoColumnsProps {
  eyebrow: string;
  title: string;
  leftText: string;
  rightText: string;
  buttonText?: string;
  theme?: 'dark' | 'light';
  showButton?: boolean;
}

const BigTitleTwoColumns: React.FC<BigTitleTwoColumnsProps> = ({
  eyebrow,
  title,
  leftText,
  rightText,
  buttonText = 'En savoir plus',
  theme = 'dark',
  showButton = true,
}) => {
  const [ref, isInView] = useInView({ threshold: 0.1, rootMargin: '0px 0px -20% 0px' });
  useAOS();

  const isDark = theme === 'dark';

  return (
    <section className={`${styles.wrapper} ${isDark ? styles.dark : styles.light}`} ref={ref}>
      <div className={`${styles.container} ${isInView ? styles.animate : ''}`}>
        <h3 className={styles.eyebrow} data-aos="fade-down">
          {eyebrow}
        </h3>
        <h1 className={styles.title} data-aos="zoom-in">
          {title}
        </h1>
        <div className={styles.columns}>
          <p className={styles.columnText} data-aos="fade">
            {leftText}
          </p>
          <p className={styles.columnText} data-aos="fade" data-aos-delay="150">
            {rightText}
          </p>
        </div>
        {showButton && buttonText && (
          <button type="button" className={styles.button} data-aos="fade-up">
            {buttonText}
          </button>
        )}
      </div>
    </section>
  );
};

export default BigTitleTwoColumns;
